import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { FormattedMessage, injectIntl } from 'react-intl'
import style from './LangSwitcher.module.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import EventOutside from '../eventOutside/eventOutside'

class LangSwitcher extends Component {
  static contextTypes = {
    language: PropTypes.object,
  }

  static propTypes = {
    showMenu: PropTypes.bool,
  }

  static defaultProps = {
    showMenu: false,
  }

  state = {
    value: '',
    show: false,
  }

  componentDidMount() {
    const { language } = this.context
    this.setState({
      value: language.locale || language.detected,
    })
  }

  handleChange = event => {
    const { language } = this.context
    const { originalPath } = language
    const { value } = event.target.dataset

    if (value === this.state.value) {
      return this.setState(() => {
        return { show: false }
      })
    }

    this.setState({ value }, () => {
      localStorage.setItem('language', value)
      let newPath = originalPath.includes('posts_') ? originalPath.replace(/\/posts_.{2}\//g, `/posts_${value}/`) : originalPath
      // TODO: remove redirect when developing ENG version
      newPath = value === 'en' && newPath.includes('/blog/') ? '/' : newPath
      window.location.href = `/${value}${newPath}`
    })
  }

  toggleVisability = () => {
    this.setState(prevState => {
      return { show: !prevState.show }
    })
  }

  closeSwitcher = () => {
    this.setState(() => {
      return { show: false }
    })
  }

  render() {
    const { language } = this.context
    const { languages } = language
    const { show, value } = this.state
    const { showMenu } = this.props

    if (!value) {
      return null
    }

    return (
      <EventOutside
        classname={style.switcherContainer}
        func={this.closeSwitcher}
      >
        <div className={style.switcher}>
          <div onClick={this.toggleVisability} className={style.chosen}>
            <FormattedMessage id="language" />
            <FontAwesomeIcon
              className={classnames(show ? style.svgRotate : null)}
              transform="shrink-6"
              icon={['fas', 'chevron-down']}
            />
          </div>
          <div
            className={classnames(
              show ? style.valuesShow : style.values,
              showMenu ? style.mobile : null
            )}
          >
            {languages.map(({ value, text }) => (
              <span onClick={this.handleChange} key={value} data-value={value}>
                {text}
              </span>
            ))}
          </div>
        </div>
      </EventOutside>
    )
  }
}

export default injectIntl(LangSwitcher)
